import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnrecoverableError = () => /*#__PURE__*/_jsxs(ErrorMessage, {
  type: "badRequest",
  children: [/*#__PURE__*/_jsx(NavMarker, {
    name: "UP_FRONT_REQUEST_ERROR"
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.errors.failedToLoadWholeApp"
    })
  })]
});
export default UnrecoverableError;